import type { HTMLAttributes } from 'react'
import { cx } from '../lib/cx'

export type BadgeVariant =
  'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'accent' | 'outline' | 'sahel' | 'indigo'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant
  dot?: boolean
}

export function Badge({ variant = 'neutral', dot = false, className, ...rest }: BadgeProps) {
  return (
    <span className={cx('badge', `badge-${variant}`, dot && 'badge-dot', className)} {...rest} />
  )
}
